export default __webpack_public_path__ + "static/media/intllight.d4a59afa.png";